<template>
<v-layout>
  
  <v-dialog
    v-model="loading"
    hide-overlay
    persistent
    width="300"
    >
    <v-card
      color="orange"
      dark
      >
      <v-card-text>
        Please stand by
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
          ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
  
  <v-col offset-md="1" md="10">

    <PointsApiStatus/>
    
    
    <v-container text-center v-if="errorState">
      <v-card
	max-width="500"
	class="mx-auto"
	color="red"
	>
	<v-card-text>
	  <span class="display-1 font-weight-medium">No data for this date</span>
	  <br/>
	  <br/>
	  <v-icon>fa-exclamation</v-icon>
	</v-card-text>
      </v-card>
    </v-container>
    
    
    <v-container v-else>
      <h1>Weasel</h1>
      <h2>Collections</h2>
      
      <v-card
	v-for="coll in collections" :key="coll.name"
	class="mx-auto"
	outlined
	>
	<v-list-item three-line>
	  <v-list-item-content>
            <div class="overline mb-4">{{ coll.collection_id }}</div>
            <v-list-item-title class="headline mb-1">{{ coll.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ coll.description }}</v-list-item-subtitle>
	  </v-list-item-content>
	</v-list-item>
	
	<v-container fluid>
	  <v-card>
	    <v-card-title><h4>Parameters</h4></v-card-title>
	    <v-divider></v-divider>
	    
	    <v-simple-table>
	      <thead>
		<tr>
		  <th class="text-left">Name</th>
		  <th class="text-left">Description</th>
		  <th class="text-left">Unit</th>
		</tr>
	      </thead>
	      <tbody>
		<tr v-for="item in coll.parameters" :key="item.name">
		  <td>{{ item.name }}</td>
		  <td>{{ item.description }}</td>
		  <td>{{ item.unit }}</td>
		</tr>
	      </tbody>
	    </v-simple-table>
	    
	  </v-card>
	</v-container>
	
	<v-card-actions>
	  <v-btn text><router-link :to="{name: 'pointsForColl', params: {collname: coll.name}}">See Points</router-link></v-btn>
	</v-card-actions>
      </v-card>
      
    </v-container>
    
  </v-col>
</v-layout>
</template>

<script>
import { config } from '../config';

import PointsApiStatus from './PointsApiStatus.vue';

export default {
    components: {
	PointsApiStatus,
    },
    
    data: () => ({
        loading: true,
        errorState: false,
        collections: [],
    }),
    
    watch: {
    },
    
    mounted() {
        this.loadData();
    },
    
    methods: {        
        loadData() {
            this.loading = true;
	    
            const url = `${config.baseUrl}weasel/collections`;
	    
            this.$http.get(url, { auth: this.$store.getters.auth }).then((res) => {
                this.collections = res.data;
                this.loading = false;
            }).catch((err) => {
                console.log(err);
                this.errorState = true;
                this.loading = false;
            });
        },
    },
};
</script>


<style lang="scss" scoped>
a {
    text-decoration: none;
}
</style>
